export default __webpack_public_path__ + "static/media/send2Pass.9666b11a.svg";